<template>
  <div>
    <v-list-item @click="handleCategoryClick">
      <v-list-item-icon>
        <v-icon v-if="categoryHasAllTasksSelected" color="primary">mdi mdi-checkbox-marked</v-icon>
        <v-icon v-else-if="categoryHasSomeTasksSelected" color="grey lighten-1">mdi mdi-minus-box</v-icon>
        <v-icon v-else color="grey lighten-2">mdi mdi-checkbox-blank</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="subtitle-1" style="height: 20px; margin-top: 2px;">
          {{ category.nameText }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-for="task in tasks" :key="task.id" @click="handleTaskClick(task)">
      <v-list-item-icon>
        <v-icon v-if="taskSelected(task.id)" color="primary">mdi mdi-checkbox-outline</v-icon>
        <v-icon v-else>mdi mdi-checkbox-blank-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="subtitle-2">{{ task.nameText }}</v-list-item-title>
        <v-list-item-subtitle class="subtitle-2">
          <v-chip x-small>
            {{ getCategoryTreeString(task) }}
          </v-chip>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="my-4"></v-divider>
  </div>
</template>

<script>
import categoryService from "@/service/category.service";

export default {
  name: "SuggestedTasksListItem",
  props: ['categoryId', 'selectedTaskIds', 'tasks'],
  methods: {
    handleCategoryClick() {
      this.$emit('category-select', this.categoryId, this.categoryHasAllTasksSelected, this.categoryHasSomeTasksSelected);
    },
    handleTaskClick(task) {
      this.$emit('task-select', task);
    },
    taskSelected(taskId) {
      return this.selectedTaskIds.findIndex(stId => stId === taskId) > -1;
    },
    getCategoryTreeString(task) {

      return categoryService.getCategoryTreeString(categoryService.getCategoryById(task.categoryId));
    }
  },
  computed: {
    category() {
      return categoryService.getCategoryById(parseInt(this.categoryId));
    },
    selectedCategoryTasks() {
      return this.tasks.filter(ct => this.selectedTaskIds.includes(ct.id));
    },
    categoryHasAllTasksSelected() {
      return this.selectedCategoryTasks.length === this.tasks.length;
    },
    categoryHasSomeTasksSelected() {
      return this.selectedCategoryTasks.length > 0 && this.selectedCategoryTasks.length < this.tasks.length;
    },

  },
}
</script>

<style scoped>

</style>
